import React, { useEffect } from "react";
import Select from "react-select";

const MultiSelectDropDown = ({
  label,
  name,
  options,
  required = false,
  errors,
  value = [],
  onChange,
  register,
  definition,
  readOnly = false, // Add the readOnly prop
}) => {
  useEffect(() => {
    if (register && name) {
      register(name, { required: required });
    }
  }, [register, name, required]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "8px",
      padding: "3px",
      borderColor: state.isFocused
        ? errors?.[name]
          ? "#f87171"
          : "#93c5fd"
        : errors?.[name]
        ? "#f87171"
        : "#d1d5db",
      boxShadow: state.isFocused
        ? errors?.[name]
          ? "0 0 0 2px #fecaca"
          : "0 0 0 2px #bfdbfe"
        : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#93c5fd" : "#d1d5db",
      },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#dbeafe",
      color: "#1e3a8a",
      borderRadius: "5px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#1e3a8a",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#1e3a8a",
      ":hover": {
        backgroundColor: "#bfdbfe",
        color: "#1e40af",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#dbeafe" : base.backgroundColor,
      color: state.isSelected ? "#1e3a8a" : base.color,
      "&:hover": {
        backgroundColor: state.isSelected ? "#bfdbfe" : "#f3f4f6",
      },
      display: "flex",
      alignItems: "center",
    }),
  };

  const handleChange = (selectedOptions) => {
    if (readOnly) return; // Prevent any changes if readOnly is true
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    if (onChange) {
      onChange(selectedValues); // Pass the values to parent
    }
  };

  // Ensure value is always an array and handle undefined/null cases
  const safeValue = Array.isArray(value) ? value : [];
  const selectedOptions = options?.filter((option) =>
    safeValue.includes(option.value)
  ) || [];

  // Custom Option component with checkbox
  const Option = ({
    innerRef,
    innerProps,
    isFocused,
    isSelected,
    children,
  }) => {
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`flex items-center px-3 py-2 cursor-pointer ${
          isFocused ? "bg-gray-100" : ""
        }`}
      >
        <input type="checkbox" checked={isSelected} readOnly className="mr-2" />
        {children}
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="font-bold text-base">
        {label}
        {required && <span className="text-red-500 text-xs ml-0.5">*</span>}
      </label>
      {definition && <p className="text-gray-500 text-xs">{definition}</p>}
      <Select
        isMulti
        name={name}
        options={options}
        value={selectedOptions} // Use the converted value
        onChange={handleChange}
        styles={customStyles}
        className="basic-multi-select"
        classNamePrefix="select"
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option,
        }}
        isDisabled={readOnly} // Disable the select if readOnly is true
      />
      {errors?.[name] && (
        <p className="text-red-500 text-xs">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default MultiSelectDropDown;
